module.exports = __webpack_public_path__ + "img/pants.fd6b76ca.svg";